import React, { createContext } from 'react'
import { useEffect, useState } from 'src/hooks'

type RecaptchaContextType = {
  isReady: boolean
  siteKey: string | null
}

export const RecaptchaContext = createContext<RecaptchaContextType>({
  isReady: false,
  siteKey: null,
})

export const RecaptchaProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isReady, setIsReady] = useState(false)
  const siteKey = process.env.REACT_APP_RECAPTCHA_KEY || null

  useEffect(() => {
    if (!siteKey) return

    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`
    script.async = true
    script.onload = () => setIsReady(true)
    document.body.appendChild(script)
  }, [siteKey])

  return (
    <RecaptchaContext.Provider value={{ isReady, siteKey }}>
      {children}
    </RecaptchaContext.Provider>
  )
}
